export const environment = {
  production: false,

  identityApiUrl: 'http://localhost:8080',

  restaurantApiUrl: 'http://localhost:8081',

  menuApiUrl: 'http://localhost:8082',
  orderingApiUrl: 'http://localhost:8083'
};